import { setLocale } from "yup";

setLocale({
    mixed: {
        required: "This field is required",
    },
});

export default {};
